import React from 'react'
import axios from 'axios';
import { Button } from '@material-ui/core';
import { blue } from '@material-ui/core/colors';
import { Link } from 'react-router-dom'




import BottomNavigation from 'components/BottomNavigation'
import Loading from 'components/Loading'
import Header from 'components/Header'
import Matrix from 'scripts/Matrix'
import style from 'style/consult/ConsultRequestItem.css'

class ConstultRequests extends React.Component {
  componentDidMount() {

  }
  fullName = (patient) => {
    return patient.fname + ((patient.lname && patient.fname) && ' ') + patient.lname
  }
  showQuiz = (quizId) => {

  }
  render() {
    return (
      <div class="consult-request-item card">
        <div class='cs-row cs-name'>
          <div class='cs-label'>نام بیمار</div>
          <div class='cs-value'>{this.fullName(this.props.consultRequest.patient)}</div>
        </div>
        <div class='cs-row cs-question'>
          <div class='cs-label'>عنوان سوال</div>
          <div class='cs-value'>{this.props.consultRequest.question}</div>
        </div>
        <div class='cs-row cs-category'>
          <div class='cs-label'>دسته بندی</div>
          <div class='cs-value'>{this.props.consultRequest.ConsultCategory.name}</div>
        </div>
        <div class='cs-actions'>
          <div class='cs-showQuiz'>
            <Link to={'/quiz/' + this.props.consultRequest.id}><Button size="large" >نمایش تست</Button></Link>
          </div>
          <div class='cs-acceptPatient'>
            <Button size="large" fullWidth={true}
              onClick={() => { this.props.showModalCallBack(this.props.consultRequest.id) }}>
              پذیرش بیمار
            </Button>
          </div>
        </div>
      </div>
    )
  }
}
export default ConstultRequests;